import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "ytb-home"
};
const _hoisted_2 = {
  class: "ytb-home__grid"
};
const _hoisted_3 = {
  class: "ytb-tool-card__head"
};
const _hoisted_4 = {
  key: 0,
  class: "ytb-tool-card__tag"
};
const _hoisted_5 = {
  class: "ytb-tool-card__title"
};
const _hoisted_6 = {
  class: "ytb-tool-card__desc"
};
const _hoisted_7 = {
  key: 0,
  class: "ytb-tool-card__pipeline"
};
const _hoisted_8 = {
  key: 0,
  class: "ytb-tool-card__pipeline-arrow"
};
export default {
  __name: 'YtbHome',
  setup(__props) {
    const tools = [{
      path: '/ytb/youtube',
      icon: '▶️',
      iconClass: 'hot',
      title: 'YouTube 工具',
      desc: '视频与 Shorts 下载，Shorts 热门采集结果按发布时间展示'
    }, {
      path: '/ytb/studio',
      icon: '🎞️',
      iconClass: 'ai',
      title: 'AI 自动出片',
      desc: '按主题一键走通词→图→视频，AI 大模型驱动批量生产；制片台、编排台、配音对图、字幕断句与分镜拆解',
      featured: true,
      pipeline: ['词', '图', '视频']
    }, {
      path: '/ytb/scys-deepsea',
      icon: '🍩',
      iconClass: 'lock',
      title: '甜甜圈文章',
      desc: '发家致富甜甜圈采集文章，需密码访问'
    }];
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"ytb-home__orbs\" aria-hidden=\"true\" data-v-2c9fa1a2><span class=\"ytb-home__orb ytb-home__orb--1\" data-v-2c9fa1a2></span><span class=\"ytb-home__orb ytb-home__orb--2\" data-v-2c9fa1a2></span><span class=\"ytb-home__orb ytb-home__orb--3\" data-v-2c9fa1a2></span></div><header class=\"ytb-home__hero\" data-v-2c9fa1a2><span class=\"ytb-home__badge\" data-v-2c9fa1a2>短视频 · AI 出片</span><h1 data-v-2c9fa1a2>AI 自动出片工具箱</h1><p data-v-2c9fa1a2>面向短视频自媒体：YouTube 素材与热点、AI 词生图生视频自动出片、字幕断句与配音配图、内容采集与运营参考</p></header>", 2)), _createElementVNode("main", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tools, tool => {
        return _createVNode(_component_router_link, {
          key: tool.path,
          to: tool.path,
          class: _normalizeClass(["ytb-tool-card", {
            'ytb-tool-card--featured': tool.featured
          }])
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            class: _normalizeClass(["ytb-tool-card__icon", tool.iconClass])
          }, _toDisplayString(tool.icon), 3), tool.featured ? (_openBlock(), _createElementBlock("span", _hoisted_4, "核心能力")) : _createCommentVNode("", true)]), _createElementVNode("h3", _hoisted_5, _toDisplayString(tool.title), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(tool.desc), 1), tool.pipeline ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tool.pipeline, (step, idx) => {
            return _openBlock(), _createElementBlock("span", {
              key: step,
              class: "ytb-tool-card__pipeline-step"
            }, [_createTextVNode(_toDisplayString(step), 1), idx < tool.pipeline.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "→")) : _createCommentVNode("", true)]);
          }), 128))])) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "ytb-tool-card__enter",
            "aria-hidden": "true"
          }, "进入", -1))]),
          _: 2
        }, 1032, ["to", "class"]);
      }), 64))])]);
    };
  }
};